import {
    Edit,
    SimpleForm,
    TextInput,
    useTranslate,
    useRecordContext,
    required,
    ReferenceInput,
    SelectInput,
    useDataProvider,
    NumberInput,
    minValue,
    AutocompleteInput,
} from 'react-admin';

import { Faqs } from "../../custom";
import { EditToolbar } from "../../common/EditToolbar";
import HTMLEditorInput, { validHtml } from "../../common/inputs/HTMLEditorInput";
import PermissionGuard from '../../common/PermissionGuard';
import useIsPermission from '../../hooks/useIsPermission';
import { useEffect, useState } from 'react';
import { FaqCategoryRender } from './FAQCreate';

const FAQEdit = () => {
    const { isUpdatable } = useIsPermission("FAQS");
    const dataProvider = useDataProvider();
    const [faqCategory, setFaqCategory] = useState([]) as any;

    useEffect(() => {
        dataProvider
            .getList('faq-categories', {
                pagination: { page: 1, perPage: 100 },
                sort: { field: 'name', order: 'ASC' },
                filter: {},
            })
            .then(({ data }) => setFaqCategory(data))
            .catch((error) => console.error(error));
    }, [dataProvider]);
    return (
        <PermissionGuard permission={isUpdatable}>
            <Edit
                mutationMode={'pessimistic'}
                title={<Title />}>
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="question" fullWidth validate={[required()]} />
                    <HTMLEditorInput source={'answer'} fullWidth validate={[required(), validHtml]} />
                    <NumberInput
                        source="displayOrder"
                        fullWidth
                        validate={[required(), minValue(1)]}
                    />
                    <AutocompleteInput
                        source="categoryId"
                        choices={faqCategory}
                        optionText={FaqCategoryRender}
                        fullWidth
                        validate={[required()]}
                    />
                </SimpleForm>
            </Edit>
        </PermissionGuard>
    )
}

const Title = () => {
    const record = useRecordContext<Faqs>();
    const translate = useTranslate();

    return record ? (
        <span>
            {translate('resources.faqs.name', { smart_count: 1 })} &quot;
            {record.display_order}&quot;
        </span>
    ) : null;
};

export default FAQEdit;
